module.exports = __webpack_public_path__ + "7b770d6c53423deb1a8e49d3c9175184.woff2";